/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookies from 'js-cookie'

const getCookie = (name: string) => {
  const rawValue = Cookies.get(name)
  if (!rawValue) {
    return null
  }
  let parsedValue
  try {
    parsedValue = JSON.parse(rawValue)
  }
  catch {
    parsedValue = rawValue
  }
  return parsedValue
}
const setCookie = (name: string, value: any | string) => {
  const stringifiedValue = typeof value === 'string'
    ? value
    : JSON.stringify(value)
  Cookies.set(name, stringifiedValue)
}
const removeCookie = (name: string) => {
  Cookies.remove(name)
}

export default {
  getCookie,
  setCookie,
  removeCookie
}
